// serialize to localstorage

import {
  AppState,
  SerializedState,
  TrackId,
  TrackStorage,
  DEFAULT_ZOOM_IDX,
  Updates,
  idxToZoom,
} from "./lib";

export const initState: AppState = {
  trackId: "iHwl9fxmRpc",
  trackError: null,
  mode: "loop",
  position: 0,
  duration: 1000,
  markers: [],
  editingMarkers: null,
  currentSectionIdx: 0,
  activeSectionIdx: 0,
  activeMarkerIdx: null,
  scrubbing: false,
  muted: false,
  playing: false,
  following: true,
  zoomIdx: DEFAULT_ZOOM_IDX,
  zoom: idxToZoom(DEFAULT_ZOOM_IDX),
  centerProgress: null,
  history: [{ markers: [] }],
  historyIdx: 0,
};

// reset some settings when a new track is loaded.
export const initLoadState: Updates = {
  history: [{ markers: [] }],
  historyIdx: 0,
  duration: 0,
  trackError: null,
  zoomIdx: DEFAULT_ZOOM_IDX,
  zoom: idxToZoom(DEFAULT_ZOOM_IDX),
};

export function serialize(state: AppState): SerializedState {
  // duration is because youtube doesn't load until interacted with, and so we
  // don't know the duration until a video is started.
  const { duration, history, historyIdx } = state;
  return {
    history,
    historyIdx,
    duration,
    modified: Date.now(),
  };
}

// deserialize from localstorage
export function deserialize(
  stored: SerializedState,
  state: Partial<AppState> = {}, // allows keeping some state between tracks.
): AppState {
  // throw out props that don't have a state representation
  const { modified, ...st } = stored;
  return { ...initState, ...state, ...st };
}

function writeTrack(track: TrackId, toStored: SerializedState) {
  const trackStorage = readTracksObj();
  trackStorage[track] = toStored;
  localStorage.setItem("tracks", JSON.stringify(trackStorage));
}

function readTracksObj(): TrackStorage {
  const tracksStr = localStorage.getItem("tracks");
  return tracksStr ? JSON.parse(tracksStr) : {};
}

export function read(track: TrackId): SerializedState | null {
  const tracksObj = readTracksObj();
  if (!tracksObj[track]) return null;
  return tracksObj[track];
}

export function save(state: AppState) {
  writeTrack(state.trackId, serialize(state));
}
